"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = exports.USER_PERSON_TYPE = exports.USER_TYPE = void 0;
/** Helpers */
var helpers_1 = require("../helpers");
/** Services */
var main_1 = require("../main");
/** Classes */
var request_handler_1 = require("../class/request-handler");
var USER_TYPE;
(function (USER_TYPE) {
    USER_TYPE["PROSPECT"] = "prospect";
    USER_TYPE["CLIENTE"] = "cliente";
    USER_TYPE["FULL_PROSPECT"] = "full prospect";
    USER_TYPE["UNIDENTIFIED"] = "tipo cliente non identificato";
})(USER_TYPE = exports.USER_TYPE || (exports.USER_TYPE = {}));
var USER_PERSON_TYPE;
(function (USER_PERSON_TYPE) {
    USER_PERSON_TYPE["PERSONA_GIURIDICA"] = "Persona Giuridica";
    USER_PERSON_TYPE["PERSONA_FISICA"] = "Persona Fisica";
    USER_PERSON_TYPE["PERSONA_FISICA_O_GIURIDICA"] = "Persona Fisica o Giuridica";
})(USER_PERSON_TYPE = exports.USER_PERSON_TYPE || (exports.USER_PERSON_TYPE = {}));
var UserService = /** @class */ (function (_super) {
    __extends(UserService, _super);
    function UserService() {
        return _super.call(this) || this;
    }
    /** Returns the infoUtente */
    UserService.prototype.getInfoUtente = function () {
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        helpers_1.ConsoleHelper.log("[Request] infoUtente");
                        commonNetworkService = new main_1.CommonNetworkService();
                        return [4 /*yield*/, this.handleRequest(function () {
                                return commonNetworkService.get(UserService.context + UserService.version + "/me/infoUtente", {
                                    headers: {
                                        infootp: true,
                                        infoprospect: true,
                                        posticipaPrivacy: false,
                                    },
                                }, true);
                            })];
                    case 1:
                        response = _a.sent();
                        helpers_1.ConsoleHelper.log("<Response> infoUtente: ", response);
                        return [2 /*return*/, Object.keys(response).length > 0 ? response : {}];
                }
            });
        });
    };
    UserService.prototype.getAccount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var commonNetworkService, completeUrl, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        helpers_1.ConsoleHelper.log("[Request] getAccount");
                        commonNetworkService = new main_1.CommonNetworkService();
                        completeUrl = UserService.context + UserService.version + "/me/account";
                        return [4 /*yield*/, commonNetworkService.get(completeUrl)];
                    case 1:
                        response = _a.sent();
                        helpers_1.ConsoleHelper.log("<Response> getAccount: ", response);
                        return [2 /*return*/, Object.keys(response).length > 0 ? response : {}];
                }
            });
        });
    };
    /** Returns the user classification type */
    UserService.prototype.getUserType = function (classification) {
        switch (classification) {
            case "0":
                return USER_TYPE.FULL_PROSPECT;
            case "1":
                return USER_TYPE.PROSPECT;
            case "2":
                return USER_TYPE.CLIENTE;
            default:
                return USER_TYPE.UNIDENTIFIED;
        }
    };
    UserService.prototype.getUserPersonType = function (personType) {
        switch (personType) {
            case "PG":
                return USER_PERSON_TYPE.PERSONA_GIURIDICA;
            case "PF":
                return USER_PERSON_TYPE.PERSONA_FISICA;
            default:
                return USER_PERSON_TYPE.PERSONA_FISICA_O_GIURIDICA;
        }
    };
    UserService.className = "UserService";
    UserService.context = "/api/priv/contesto-utente";
    UserService.version = "/v1";
    return UserService;
}(request_handler_1.RequestHandler));
exports.UserService = UserService;
